import MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry from "../../../sections/DirectiveEntry/entries/ExecutionEntry";

const ExecutionEntryOnGoingFinancialReview = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry />
    </>
  );
}

export default ExecutionEntryOnGoingFinancialReview;
